/* React */
import React from "react";

/* Stylesheet */
import styles from "./Label.module.scss";

/* Interfaces */
interface LabelProps {
  label: string;
}

const Label: React.FC<LabelProps> = ({ label }) => {
  return <div className={styles.label}>{label}</div>;
};

export default Label;
